import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_glcode_RowClass} from "../../dbschema";

export class GlcodeContainerModel extends BaseContainerModel {
  bl_fi_mst_glcode: bl_fi_mst_glcode_RowClass = new bl_fi_mst_glcode_RowClass();
}
